import React, {useEffect, useState} from 'react';
import {QuestionOption} from "./QuestionOption";


export function QuestionOptions(props) {



    const[multipleChoiceDone, setMultipleChoiceDone] = useState(false);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(props.options);
    }, [props.options]);


    if (options != null) {

            return (
                <div className={"d-flex flex-column mt-4"}>
                    {


                        options.map((option, idx) => (
                            <div key={idx}>
                                <QuestionOption index={idx} option={option} disabled={props.disabled} displayAnswers={props.displayAnswers} nextQuestionCallback={props.nextQuestionCallback} multipleChoice={props.multipleChoice} multipleChoiceFinished={multipleChoiceDone} selectOptionCallback={props.selectOptionCallback}/>
                            </div>
                        ))


                    }

                    {
                        props.multipleChoice && !props.disabled ?
                            <button className={"btn btn-success py-2 text-white"} onClick={() => {
                                setMultipleChoiceDone(true)
                                setTimeout(() => {
                                    setMultipleChoiceDone(false)
                                    setTimeout(() => {
                                        props.nextQuestionCallback()
                                    }, 500)
                                }, 1000)
                            }}>Avgi svar</button>
                            :
                            null
                    }


                </div>
            );

    }


}